module.exports = __webpack_public_path__ + "static/media/Melissa.dcf66aaf.jpg";